import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const TESTIMONIALS = [{
  quote: 'En dos semanas duplicamos las consultas. Los embudos ya venían armados, solo adaptamos el mensaje a nuestra clínica.',
  name: 'Camila Ferrer',
  role: 'Directora, Estudio Piel',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/96e0b97a-c25c-4d2e-9f93-1d75a7a3f27c.jpg'
}, {
  quote: 'La parte de IA me ahorra horas cada semana. Ahora publico todos los días sin depender de una agencia.',
  name: 'Martín Ríos',
  role: 'Fundador, Ríos Consultora',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/8fc2f53d-ddab-4337-8c53-19ae0939b4d6.jpg'
}, {
  quote: 'Es el nivel de diseño que esperaba de un estudio grande, pero con recursos que puedo editar yo misma.',
  name: 'Lucía Ortega',
  role: 'Marketing Lead, Nova Salud',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/555a19e3-56df-4567-94e7-16d9212681f0.jpg'
}];
export function Testimonials() {
  return <section className="relative w-full border-t border-ink/[0.07] bg-white py-28 sm:py-32 lg:py-40" data-id="element-305" data-mp="m5b2xkhwlmg8">
      <div className="mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-306" data-mp="78tup250gnxw">
        <div className="max-w-2xl" data-id="element-307" data-mp="c6v9vbzbg343">
          <p className="text-[12.5px] font-medium uppercase tracking-[0.18em] text-ink-muted" data-id="element-308" data-mp="c7wo1pbmp5q1">
            Testimonios
          </p>
          <h2 className="mt-5 text-3xl font-semibold leading-tight tracking-[-0.02em] text-ink sm:text-[2.6rem]" data-id="element-309" data-mp="zyix9jxdcw1m">
            Proyectos que ya usan nuestros recursos.
          </h2>
        </div>

        <ul className="mt-16 grid grid-cols-1 gap-6 lg:mt-20 lg:grid-cols-3" data-id="element-310" data-mp="q6cwbkp534aa">
          {TESTIMONIALS.map((t, i) => <motion.li key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex flex-col rounded-4xl border border-ink/[0.07] bg-paper-alt p-9 sm:p-10" data-id="element-311" data-mp="v3d4c15juh41" data-mpi={i}>
              <div className="flex items-center gap-1" role="img" aria-label="5 de 5 estrellas" data-id="element-312" data-mp="1ofhn6xx05xg3">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} aria-hidden="true" className="h-4 w-4 fill-violetd text-violetd" data-id="element-313" data-mp="1ekzipqjrhxv8" data-mpi={s} />)}
              </div>
              <blockquote className="mt-7 flex-1 text-[15px] font-light leading-relaxed text-ink-soft" data-id="element-314" data-mp="10s01nk4bzvlk">
                “{t.quote}”
              </blockquote>
              <div className="mt-8 flex items-center gap-3.5 border-t border-ink/[0.08] pt-7" data-id="element-315" data-mp="vrvjzqrosutr">
                <img src={t.avatar} alt={`Retrato de ${t.name}`} className="h-11 w-11 rounded-full object-cover" loading="lazy" data-id="element-316" data-mp="quc7avan0q3x" />
                <div data-id="element-317" data-mp="37i3bid8k79ik">
                  <p className="text-[14px] font-semibold text-ink" data-id="element-318" data-mp="3cfd0xsvy7l6e">{t.name}</p>
                  <p className="text-[12.5px] font-light text-ink-muted" data-id="element-319" data-mp="3cd90jkx9d4av">
                    {t.role}
                  </p>
                </div>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}